import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';
import { EshopService } from 'src/app/eshop/eshop.service';
import { setLoading } from 'src/app/redux/actions/user.actions';
import { AppState } from 'src/app/redux/app.state';
import { EshopLink, Product } from 'src/typings';
import { AddEshopLinkComponent } from '../add-eshop-link/add-eshop-link.component';

@Component({
  selector: 'app-product-eshop-links',
  templateUrl: './eshop-links.component.html',
  styleUrls: ['./eshop-links.component.scss']
})
export class EshopLinksComponent {
  @Input() set product(payload: Product | undefined) {
    this._product = payload;
    this.loadLinks();
  }

  get product() {
    return this._product;
  }

  set loading(value: boolean) {
    this.store.dispatch(setLoading({ payload: value }));
  }

  private _product: Product | undefined;

  links: EshopLink[] = [];

  columnsToDisplay = ['link', 'menu'];

  constructor(
    private dialog: MatDialog,
    private eshopService: EshopService,
    private store: Store<AppState>
  ) {}

  addLink() {
    const dialogRef = this.dialog.open(AddEshopLinkComponent);
    dialogRef.componentInstance.product = this.product;
    dialogRef.componentInstance.doneEvent.subscribe(() => {
      dialogRef.close();
      this.loadLinks();
    });
  }

  async removeLink(link: EshopLink) {
    const confirm = window.confirm('Точно удалить?');
    if (confirm) {
      await this.eshopService.deleteLink(link.id).toPromise();
      this.loadLinks();
    }
    return;
  }

  async loadLinks() {
    if (!this.product) return;
    const res = await firstValueFrom(
      this.eshopService.searchLinks({
        product_id: this.product.id
      })
    );
    this.links = res.data;
    return;
  }
}
